import { put, takeLatest, select, take, all } from 'redux-saga/effects'
import { REHYDRATE } from 'reduxjs-toolkit-persist'

import { tenantAuthFlowCompleted } from '@tabeeb/modules/account/actions'

import domainService from '@tabeeb/services/domainService'
import { formTitleFormatter, sessionTitleFormatter, trainingMaterialTitleFormatter } from '@tabeeb/shared/utils/text'

import * as rawActions from '../actions'
import { getFormsTitle, getSessionTitle, getTrainingMaterialsTitle, getVideoBridgeRegions } from '../selectors'
import * as appActions from '../../../state/actions/appActions'
import { setSelectedVideoBridge } from '../../whiteboard/actions'

import { signalrEvents, signalrConstants } from '../../signalr'
import * as notificationActions from '../../notification/actions'

function* onAppMounted(action) {
  yield take(tenantAuthFlowCompleted)
  yield put(rawActions.getConfig.request({ subdomain: domainService.subdomain }))
}

// eslint-disable-next-line require-yield
function* getVideoBridgeConfigSuccess(action) {
  window.config = action.response.data
}

function* getConfigFailed(action) {
  yield put(notificationActions.onAddErrorNotification({ message: `Tenant ${action.payload.subdomain} not found` }))
}

function* initNameFormatters(action) {
  const sessionTitle = yield select(getSessionTitle)
  sessionTitleFormatter.setTitle(sessionTitle)

  const trainingMaterialTitle = yield select(getTrainingMaterialsTitle)
  trainingMaterialTitleFormatter.setTitle(trainingMaterialTitle)

  const formTitle = yield select(getFormsTitle)
  formTitleFormatter.setTitle(formTitle)
}

function* onVideoBridgeSwitched(action) {
  const [videoBridgeUrl] = action.payload

  const videoBridgeRegions = yield select(getVideoBridgeRegions)
  let currentVideobridge
  if (videoBridgeRegions) {
    currentVideobridge = videoBridgeRegions.find((bridge) => bridge.url === videoBridgeUrl)
  }

  if (currentVideobridge) {
    yield put(setSelectedVideoBridge(currentVideobridge))
  }
}

function* appConfigStateSagas() {
  yield all([
    takeLatest(appActions.onAppMounted, onAppMounted),
    takeLatest(rawActions.getVideoBridgeConfig.success, getVideoBridgeConfigSuccess),
    takeLatest(rawActions.getConfig.failed, getConfigFailed),
    takeLatest(
      [appActions.onAppMounted, rawActions.getConfig.success, rawActions.onSetAppConfigState, REHYDRATE],
      initNameFormatters
    ),
    takeLatest(signalrEvents[signalrConstants.tabeebHubName].onVideoBridgeSwitched, onVideoBridgeSwitched),
  ])
}

export default appConfigStateSagas
